import Modal from 'react-bootstrap/Modal';
import { YesButton } from '../buttons/YesButton';
import { NoButton } from '../buttons/NoButton';
import './ConfirmationModal.css';

export const ConfirmationModal = ({ message, isShowing, onConfirm, onClose }) => {

    return (
        <>
            <Modal show={isShowing} onHide={onClose}>
                <Modal.Header closeButton>
                    <Modal.Title>{message}</Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <div className={'confirmation-buttons-container'}>
                        <NoButton onClick={onClose}></NoButton>
                        <YesButton onClick={onConfirm}></YesButton>
                    </div>
                </Modal.Body>
            </Modal>
        </>
    );
};